export enum UserWorkType {
	FUll_TIME = "FUll_TIME",
	REMOTE = "REMOTE",
	PARTTIME = "PARTTIME",
	HYBRID = "HYBRID",
	FREELANCE = "FREELANCE",
	INTERN = "INTERN",
	OTHER = "OTHER",
}
